export const footerLinks = [
    {
      title: "About",
      links: [
        { title: "How it works", url: "/" },
        { title: "Featured", url: "/" },
        { title: "Partnership", url: "/" },
        { title: "Bussiness Relation", url: "/" },
      ],
    },
    {
      title: "Company",
      links: [
        { title: "Events", url: "/" },
        { title: "Blog", url: "/" },
        { title: "Podcast", url: "/" },
        { title: "Invite a friend", url: "/" },
      ],
    },
    {
      title: "Socials",
      links: [
        { title: "Discord", url: "/" },
        { title: "Instagram", url: "/" },
        { title: "Twitter", url: "/" },
        { title: "Facebook", url: "/" },
      ],
    },
  ];

  export let everyDayMeals = [
    {
      id: 1,
      price: 370,
      title: 'Special Chicken Combo',
      image: 'https://www.kfcpakistan.com/images/43a95f10-ffaa-11ed-b673-4121381f04c6-CrispyDuoBox-2023-05-31115706.png',
      description: 'Enjoy a special combo with 4 pcs Hot & Crispy Chicken + 1 Large fries + 2 Regular drinks.',
    },
    {
      id: 2,
      price: 400,
      title: 'Deluxe Burger Meal',
      image: 'https://www.kfcpakistan.com/images/43a95f10-ffaa-11ed-b673-4121381f04c6-CrispyDuoBox-2023-05-31115706.png',
      description: 'Indulge in a deluxe burger meal with a juicy burger, Large fries, and a soft drink.',
    },
    {
      id: 3,
      price: 450,
      title: 'Zesty Chicken Strips',
      image: 'https://www.kfcpakistan.com/images/43a95f10-ffaa-11ed-b673-4121381f04c6-CrispyDuoBox-2023-05-31115706.png',
      description: 'Savor the zesty flavors of chicken strips served with a dipping sauce.',
    },
    {
      id: 4,
      price: 420,
      title: 'BBQ Ribs Platter',
      image: 'https://www.kfcpakistan.com/images/43a95f10-ffaa-11ed-b673-4121381f04c6-CrispyDuoBox-2023-05-31115706.png',
      description: 'Enjoy a hearty BBQ ribs platter with coleslaw and a side of corn on the cob.',
    },
    {
      id: 5,
      price: 395,
      title: 'Vegetarian Delight',
      image: 'https://www.kfcpakistan.com/images/43a95f10-ffaa-11ed-b673-4121381f04c6-CrispyDuoBox-2023-05-31115706.png',
      description: 'A vegetarian delight with a variety of fresh and tasty veggie options.',
    },
    {
      id: 6,
      price: 410,
      title: 'Sizzling Steakhouse Combo',
      image: 'https://www.kfcpakistan.com/images/43a95f10-ffaa-11ed-b673-4121381f04c6-CrispyDuoBox-2023-05-31115706.png',
      description: 'A sizzling combo featuring a delicious steak, sides, and a refreshing drink.',
    },
    {
      id: 7,
      price: 390,
      title: 'Crunchy Seafood Platter',
      image: 'https://www.kfcpakistan.com/images/43a95f10-ffaa-11ed-b673-4121381f04c6-CrispyDuoBox-2023-05-31115706.png',
      description: 'Dive into a seafood platter filled with crispy fish, shrimp, and more.',
    },
  ];
  export let sellerMeals = [
    {
      id: 1,
      price: 370,
      title: 'Special Chicken Combo',
      image: 'https://www.kfcpakistan.com/images/43a9fb50-ffaa-11ed-8180-812e571998fe-krunch_variant_0-2023-05-31115706.png',
      description: 'Enjoy a special combo with 4 pcs Hot & Crispy Chicken + 1 Large fries + 2 Regular drinks.',
    },
    {
      id: 2,
      price: 400,
      title: 'Deluxe Burger Meal',
      image: 'https://www.kfcpakistan.com/images/43a9fb50-ffaa-11ed-8180-812e571998fe-krunch_variant_0-2023-05-31115706.png',
      description: 'Indulge in a deluxe burger meal with a juicy burger, Large fries, and a soft drink.',
    },
    {
      id: 3,
      price: 450,
      title: 'Zesty Chicken Strips',
      image: 'https://www.kfcpakistan.com/images/43a9fb50-ffaa-11ed-8180-812e571998fe-krunch_variant_0-2023-05-31115706.png',
      description: 'Savor the zesty flavors of chicken strips served with a dipping sauce.',
    },
    {
      id: 4,
      price: 420,
      title: 'BBQ Ribs Platter',
      image: 'https://www.kfcpakistan.com/images/43a9fb50-ffaa-11ed-8180-812e571998fe-krunch_variant_0-2023-05-31115706.png',
      description: 'Enjoy a hearty BBQ ribs platter with coleslaw and a side of corn on the cob.',
    },
  ];
  
  export let promotions = [
    {
      id: 1,
      price: 370,
      title: 'Krunch Burger',
      image: 'https://www.kfcpakistan.com/images/43a95f10-ffaa-11ed-b673-4121381f04c6-CrispyDuoBox-2023-05-31115706.png',
      description: 'Turn up the fun with 5 pcs Hot & Crispy Chicken + 1 Large fries + 2 Regular drinks',
    },
    {
      id: 2,
      price: 370,
      title: 'Krunch Burger',
      image: 'https://www.kfcpakistan.com/images/43a95f10-ffaa-11ed-b673-4121381f04c6-CrispyDuoBox-2023-05-31115706.png',
      description: 'Turn up the fun with 5 pcs Hot & Crispy Chicken + 1 Large fries + 2 Regular drinks',
    },
    {
      id: 3,
      price: 370,
      title: 'Krunch Burger',
      image: 'https://www.kfcpakistan.com/images/43a95f10-ffaa-11ed-b673-4121381f04c6-CrispyDuoBox-2023-05-31115706.png',
      description: 'Turn up the fun with 5 pcs Hot & Crispy Chicken + 1 Large fries + 2 Regular drinks',
    },
    {
      id: 4,
      price: 370,
      title: 'Krunch Burger',
      image: 'https://www.kfcpakistan.com/images/43a95f10-ffaa-11ed-b673-4121381f04c6-CrispyDuoBox-2023-05-31115706.png',
      description: 'Turn up the fun with 5 pcs Hot & Crispy Chicken + 1 Large fries + 2 Regular drinks',
    },
]
export let signaturebox = [
  {
    id: 1,
    price: 650,
    title: 'Crispy Box',
    image: 'https://www.kfcpakistan.com/images/43aa4970-ffaa-11ed-9c55-3705f003c528-CrispyBox-2023-05-31115706.png',
    description: 'In mood for something crispy? Get 2 pcs Hot & Crispy Chicken + 1 Regular fries + 1 Regular drink + 1 Coleslaw',
  },
  {
    id: 2,
    price: 670,
    title: 'Boneless Box',
    image: 'https://www.kfcpakistan.com/images/43a95f10-ffaa-11ed-b673-4121381f04c6-BonelessBox-2023-05-31115706.png',
    description: 'Hassle free boneless experience with 4 Chicken strips + 1 Coleslaw + 1 Regular fries + 1 Regular drink + 1 Dip + 1 Dinner',
  },
  {
    id: 3,
    price: 950,
    title: 'Wow Box',
    image: 'https://www.kfcpakistan.com/images/43a9fb50-ffaa-11ed-8180-812e571998fe-WowBox-2023-05-31115706.png',
    description: 'Feel good with 1 Signature Zinger + 1 pc Hot & Crispy Chicken + 1 Regular fries + 1 Regular drink + 1 Coleslaw',
  },
  {
    id: 4,
    price: 1250,
    title: 'Crispy Duo Box',
    image: 'https://www.kfcpakistan.com/images/43a95f10-ffaa-11ed-b673-4121381f04c6-CrispyDuoBox-2023-05-31115706.png',
    description: 'Turn up the fun with 5 pcs Hot & Crispy Chicken + 1 Large fries + 2 Regular drinks',
  },
]
export let sharing = [
  {
    id: 1,
    price: 1890,
    title: 'Value Bucket',
    image: 'https://www.kfcpakistan.com/images/43a95f10-ffaa-11ed-b673-4121381f04c6-value-Bucket-2023-05-31115706.png',
    description: 'Our pride and joy: hand-breaded and fried to perfection in house. 9 pcs of Colonel’s Signature Crispy Fried Chicken. It"s finger lickin" good. Rs. 50 from Every Bucket Sold Goes to Mitao Bhook Foundation.',
  },
  {
    id: 2,
    price: 2050,
    title: 'Family Festival 1',
    image: 'https://www.kfcpakistan.com/images/43a98620-ffaa-11ed-b6b3-6970cc1cd666-family-Festivle-1-2023-05-31115706.png',
    description: 'A feel-good meal for the fam. It includes 4 Krunch burgers+ 4 pieces Hot and Crispy Chicken+ 2 Dinner Rolls + 1.5 Liter drink',
  },
  {
    id: 3,
    price: 2250,
    title: 'Family Festival 2',
    image: 'https://www.kfcpakistan.com/images/43a98620-ffaa-11ed-b6b3-6970cc1cd666-Family-Festivle-2-2023-05-31115706.png',
    description: 'A hearty meal for the fam. It includes 2 Zinger burgers + 2 Krunch burgers + 4 pieces Hot and Crispy Chicken + 2 Dinner rolls + 1.5 Liter drink',
  },
  {
    id: 4,
    price: 2450,
    title: 'Family Festival 3',
    image: 'https://www.kfcpakistan.com/images/43a9fb50-ffaa-11ed-8180-812e571998fe-family-Festivle-3-2023-05-31115706.png',
    description: 'An ultimate meal for the fam. It includes 4 Zinger burgers + 4 pieces Hot and Crispy Chicken + 2 Dinner rolls + 1.5 Liter drink',
  },
]
export let snacks = [
  {
    id: 1,
    price: 90,
    title: 'Dinner Roll',
    image: 'https://www.kfcpakistan.com/images/62153aa0-0513-11ee-8eee-c7aabf77bad4-Dinner-Roll-copy_variant_0-2023-06-07091210.png',
    description: 'Dinner Roll',
  },
  {
    id: 2,
    price: 50,
    title: 'Mineral Water 500ml',
    image: 'https://www.kfcpakistan.com/images/61ea8120-0513-11ee-b037-a334837c64cb-Water_variant_0-2023-06-07091210.png',
    description: 'Mineral Water 500ml',
  },
  {
    id: 3,
    price: 150,
    title: 'Coleslaw',
    image: 'https://www.kfcpakistan.com/images/43a98620-ffaa-11ed-b6b3-6970cc1cd666-Coleslaw_variant_0-2023-05-31115706.png',
    description: 'Coleslaw',
  },
  {
    id: 4,
    price: 245,
    title: 'Fries',
    image: 'https://www.kfcpakistan.com/images/43a9fb50-ffaa-11ed-8180-812e571998fe-RegularFries_variant_0-2023-05-31115706.png',
    description: 'Fries',
  },
]
export let midnight = [
  {
    id: 1,
    price: 90,
    title: 'Dinner Roll',
    image: 'https://www.kfcpakistan.com/images/62153aa0-0513-11ee-8eee-c7aabf77bad4-Dinner-Roll-copy_variant_0-2023-06-07091210.png',
    description: 'Dinner Roll',
  },
  {
    id: 2,
    price: 50,
    title: 'Mineral Water 500ml',
    image: 'https://www.kfcpakistan.com/images/61ea8120-0513-11ee-b037-a334837c64cb-Water_variant_0-2023-06-07091210.png',
    description: 'Mineral Water 500ml',
  },
  {
    id: 3,
    price: 150,
    title: 'Coleslaw',
    image: 'https://www.kfcpakistan.com/images/43a98620-ffaa-11ed-b6b3-6970cc1cd666-Coleslaw_variant_0-2023-05-31115706.png',
    description: 'Coleslaw',
  },
  {
    id: 4,
    price: 245,
    title: 'Fries',
    image: 'https://www.kfcpakistan.com/images/43a9fb50-ffaa-11ed-8180-812e571998fe-RegularFries_variant_0-2023-05-31115706.png',
    description: 'Fries',
  },
]
export const restaurantAddOns = [
  {
    id: 1,
    name: 'Extra Cheese',
    image: 'https://www.kfcpakistan.com/images/61ec55e0-0513-11ee-aee5-69eb5757a047-Coleslaw-2023-06-07091210.png',
    description: 'Add extra cheese to your meal.',
    price: 100,
  },
  {
    id: 2,
    name: 'Bacon',
    image: 'https://www.kfcpakistan.com/images/6249b820-0513-11ee-9e45-cb0ed000d4a6-Dinner-Roll-copy-2023-06-07091210.png',
    description: 'Crispy bacon strips to make your meal even better.',
    price: 250,
  },
  {
    id: 3,
    name: 'Guacamole',
    image: 'https://www.kfcpakistan.com/images/6249b820-0513-11ee-9e45-cb0ed000d4a6-Dinner-Roll-copy-2023-06-07091210.png',
    description: 'Fresh guacamole for that perfect touch of creaminess.',
    price: 175,
  },
  // Add more add-ons as needed
];

